module.exports = __webpack_public_path__ + "static/logoPL-d589e40e646219ada4e74b99fd176d61.svg";